import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { ChevronDown, Check, Search } from "lucide-react";

export default function MultiSelect({ options, value = [], onChange, placeholder = "Seleziona…", testid, searchable = false, triggerClassName = "w-56" }) {
  const [q, setQ] = useState("");
  const toggle = (v) => {
    if (value.includes(v)) onChange(value.filter((x) => x !== v));
    else onChange([...value, v]);
  };
  const label =
    value.length === 0
      ? placeholder
      : value.length === 1
      ? options.find((o) => o.value === value[0])?.label || "1 selezionato"
      : `${value.length} selezionati`;

  const norm = (s) => (s || "").toString().toLowerCase();
  const filtered = searchable && q.trim() ? options.filter((o) => norm(o.label).includes(norm(q))) : options;

  return (
    <Popover onOpenChange={(open) => { if (!open) setQ(""); }}>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid={testid}
          className={`h-9 ${triggerClassName} justify-between bg-white text-sm font-normal`}>
          <span title={typeof label === "string" ? label : undefined} className={value.length ? "text-slate-900 truncate" : "text-slate-400"}>{label}</span>
          <ChevronDown className="h-4 w-4 text-slate-400 flex-shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[26rem] max-w-[90vw] p-0">
        {searchable && (
          <div className="p-2 border-b border-slate-100">
            <div className="relative">
              <Search className="absolute left-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-400" />
              <input autoFocus data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)}
                placeholder="Cerca…"
                className="w-full pl-7 pr-2 py-1.5 text-sm rounded-md border border-slate-200 focus:outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
          </div>
        )}
        <div data-testid={testid ? `${testid}-list` : undefined}
          className="max-h-64 overflow-y-auto p-1 overscroll-contain" onWheel={(e) => e.stopPropagation()}>
          {filtered.length === 0 && <div className="px-2 py-2 text-xs text-slate-400">Nessun elemento</div>}
          {filtered.map((o) => {
            const active = value.includes(o.value);
            return (
              <button key={o.value} data-testid={`${testid}-opt-${o.value}`} onClick={() => toggle(o.value)}
                style={o.depth ? { paddingLeft: `${0.5 + o.depth * 1.25}rem` } : undefined}
                className="w-full flex items-start gap-2 px-2 py-1.5 rounded-md hover:bg-slate-100 text-sm text-left">
                <span className={`mt-0.5 h-4 w-4 rounded border flex items-center justify-center flex-shrink-0 ${active ? "bg-blue-700 border-blue-700 text-white" : "border-slate-300"}`}>
                  {active && <Check className="h-3 w-3" />}
                </span>
                <span title={typeof o.label === "string" ? o.label : undefined}
                  className={`flex-1 break-words ${o.depth ? "text-slate-600" : "font-medium text-slate-800"}`}>{o.label}</span>
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
